import { render, staticRenderFns } from "./Pointing.vue?vue&type=template&id=14773836&scoped=true"
import script from "./Pointing.vue?vue&type=script&lang=js"
export * from "./Pointing.vue?vue&type=script&lang=js"
import style0 from "./Pointing.vue?vue&type=style&index=0&id=14773836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14773836",
  null
  
)

export default component.exports